import style, { styled } from "styled-components";
import { TwoColumnGrid, smallMediaBreakpoint, spacingM, spacingS, spacingXL } from "@RooUI";

const FlexCol = style.div`
    display: flex;
    flex-direction: column;
`;

export const FormContainer = styled(FlexCol)`
  gap: ${spacingXL};
  height: 365px;

  @media (max-width: ${smallMediaBreakpoint}) {
    gap: ${spacingM};
  }
`;

export const FormHeader = styled(FlexCol)`
  gap: ${spacingS};
`;

export const FormFields = styled(FlexCol)`
  gap: ${spacingXL};

  @media (max-width: ${smallMediaBreakpoint}) {
    gap: ${spacingM};
  }
`;

export const FormFieldTwoColumnGrid = styled(TwoColumnGrid)`
  gap: ${spacingXL};
`;
